/* SPDX-License-Identifier: Apache-2.0 */
/* SPDX-FileCopyrightText: 2024-2025 OKTET LTD */
export const DEFAULT_ENABLE_PAIR_GAIN_COLUMNS = false;
export const ENABLE_PAIR_GAIN_COLUMNS_KEY = 'enablePairGainColumns';
